<template>
    <div class="row">
        <div class="col-md-12">
            <div class="row mt-3">
                <div class="col-md-12">
                    <div class="form-group mt-">
                        <label style="font-size: 20px;">Customer Notes</label>
                        
                    </div>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-md-12">
                    <table class="table" cellspacing="0" cellpadding="0">
                        <thead>
                        <tr>
                            <th></th>
                            <th>Date</th>
                            <th>Time</th>
                            <th>Added By</th>
                            <th>Note</th>
                        </tr>
                        </thead>
                        <tbody>
                            <template v-if="customerNotes.length > 0">
                                <tr :key="notes.id" v-for="(notes, index) in customerNotes">
                                    <td>{{ index+1 }}</td>
                                    <td>{{ notes.note_date }}</td>
                                    <td>{{ notes.note_time }}</td>
                                    <td>
                                        <template v-if="notes.admin">
                                            {{ notes.admin.name }}
                                        </template>
                                        <template v-else> -- </template>
                                    </td>
                                    <td>{{ notes.note }}</td>
                                </tr>
                            </template>
                            <template v-else>
                                <tr>
                                    <td colspan="5" class="text-center">No Notes Found</td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                </div>
            </div>
            <hr>
            <div class="row mt-3">
                <div class="col-md-12">
                    <label for="extra_note" class="form-label"> Add Note </label>
                    <textarea id="extra_note" cols="10" placeholder="Extra Note" style="resize: none;" v-model="noteComment"></textarea>
                </div>
            </div>
            <div class="row mt-2">
                <div class="col-md-4">
                    <button class="button mt-1" @click="addCustomerNote"><span> Add Note </span></button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:'CustomerNotesModal',
    props:{
        customerID:Number,
        customerNote:Array
    },
    data(){
        return {
            customerNotes:this.customerNote,
            noteComment:null
        }
    },
    methods:{
        addCustomerNote(){
            this.$store.dispatch('setLoadStatus')
            fetch(`${this.$api}customer-note/add-note`, {
                method: 'POST',
                body: JSON.stringify({
                    customer_id: this.customerID,
                    comment: this.noteComment
                }),
                headers: {
                    "Content-Type": "application/json",
                    'Accept': 'application/json',
                    'Authorization': localStorage.getItem('token')
                }
            })
            .then(res => res.json())
            .then(response => {
                this.$store.dispatch('setLoadStatus')
                if (response.status) {
                    this.customerNotes = response.note_list
                    this.noteComment = null;
                }
                
            })
            .catch((error) => {
                this.$store.dispatch('setLoadStatus')
                
            })
        },
        
    }
}
</script>